import styled from 'styled-components';
import palette from '@mlc/mlc-palette';
import { ScreenSize, FontFamily } from '../../../../../enums';
import TrackableAnchor from '../../../../common/Anchor/TrackableAnchor';

export const LinkSection = styled.section`
	box-sizing: border-box;
	flex: 0 0 25%;
	max-width: 25%;
	padding: 0 15px;

	@media (max-width: ${ScreenSize.medium}) {
		flex: none;
		max-width: 100%;
		padding: 0 15px 15px 15px;
	}
`;

export const Anchor = styled(TrackableAnchor)`
	color: ${palette.mlcAqua};
	text-decoration: none;

	&:focus,
	&:hover {
		color: ${palette.mlcDeepAqua};
		text-decoration: underline;
	}
`;
